module.exports = __webpack_public_path__ + "assets/bell_icn@1x.4c5ab7d9.svg";